<template>
	<v-container class="rc-padding fluid">
        <div class="rc-subdata">
            <div class="subdata__dato" v-html="clientesMicro"></div>
            <div class="show__bar"></div>
            <div class="subdata__dato" v-html="clientesEmpresariales"></div>
            <div class="show__bar"></div>
            <div class="subdata__dato" v-html="fondeadores"></div>
            <div class="show__bar"></div>
            <div class="subdata__dato" v-html="facturas"></div>
        </div>
	</v-container>
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
	
	@Component({
		props: {
			clientesMicro : String,
			clientesEmpresariales : String,
			fondeadores : String,
			facturas : String
        },
	})
	export default class SubData extends Vue {}
</script>

<style lang="scss" scoped>
	.rc-subdata{
        display: flex;
        justify-content: space-evenly;
        .subdata__dato{
            text-align: center;
            color: $rc-prim-g1;
            font-size: 1rem;
            font-weight: 500;
            display: flex;
            align-items: center;
        }
        .show__bar{
            border-left: 1px solid $rc-prim-g1;
            
        }
        
    }
	// Breakpoints 
	@each $breakpoint in $breakpoints_screen_text{
		@include breakpoint_media_queries($breakpoint){
			@if $breakpoint == "x-large"{
				
			}@else if $breakpoint == "large"{
				
			}@else if $breakpoint == "medium-to-large"{
				.rc-subdata{
                    justify-content: space-between;
                }
			}@else if $breakpoint == "small-to-medium"{
                .rc-subdata{
                    justify-content: space-between;
                    .subdata__dato{
                        font-size: 0.9rem;
                    }
                }
			}@else if $breakpoint == "small"{
                .rc-subdata{
                    flex-flow: column;
                    .subdata__dato{
                        justify-content: center;
                        margin-bottom: 2rem;
                    }
                    .show__bar{
                        display: none;
                    }
                }
            }
		}
	}
</style>
